import { DashboardView } from '@/features/dashboard/dashboard-view';

export function StoreDashboardPage() {
  return <DashboardView scope="store" />;
}
